<template>
  <div>
    <div id="app" :class="`${this.$route.name.toLowerCase().trim()} bg-default overflow-auto`" v-if="retrieved">
      <!-- Barre principale de navigation -->
      <BaseNavBar v-if="!this.$route.meta.sidebar" />
      <main class="main flex content">
        <SideBar v-if="this.$route.meta.sidebar && !isAdmin" />
        <SideBarAdmin v-if="this.$route.meta.sidebar && isAdmin" />
        <div :class="this.$route.meta.sidebar ? 'content-w-sidebar p-5 bg-variant w-full' : 'w-full'">
          <router-view />
          <!-- PrimeVue Messages -->
          <Toast />
          <ConfirmDialog />
          <!-- Fin des PrimeVue Messages -->
        </div>
      </main>
      <BaseFooter v-if="!this.$route.meta.sidebar" />

      <!--
      <Button
        @click="visibleBottom = true"
        class="bg-purple z-50" id="dev-space-btn"
        icon="mdi-hammer-wrench"
        :icon-size="30"
      />
      -->

      <Sidebar :visible.sync="visibleBottom" :baseZIndex="1000" position="bottom" class="p-sidebar-md" id="dev-space">
          <Button
            @click='adminMode'
            class="bg-purple"
            label="Mode admin"
            :icon="isAdmin ? 'mdi-eye-off' : 'mdi-eye'"
            :icon-size="20"
          />

        <h2>Sitemap</h2>

          <div class="flex">
            <TabMenu :model="sitemap" />
          </div>
          <div class="flex">
            <TabMenu :model="sitemap_admin" />
          </div>

          <Button
            @click="visibleBottom = false"
            class="p-button-rounded bg-purple" id="dev-space-btn"
            icon="mdi-close"
            icon-size="30"
          />
      </Sidebar>
      <!-- Fin des outils de développement -->

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BaseFooter from "~/components/Layout/Footer.vue";
import BaseNavBar from "~/components/Layout/NavBar.vue";
import SideBar from "~/components/Layout/SideBar.vue";
import SideBarAdmin from "~/components/Layout/SideBarAdmin.vue";
import ConfirmDialog from "primevue/confirmdialog";

export default {
  components: {
    BaseNavBar,
    BaseFooter,
    SideBar,
    SideBarAdmin,
    ConfirmDialog,
  },
  data: () => ({
    retrieved: false,
    windowSize: 0,
		visibleBottom: false,
    checked: true,
    sitemap: [
        {label: 'Accueil', to: '/'},
        {label: 'Authentification', to: '/authentification'},
        {label: 'Compte', to: '/mon-compte'},
        {label: 'Dashboard', to: '/dashboard'},
        {label: 'Création de projet', to: '/projects/create'},
        {label: 'Édition de projet', to: '/projects/edit/1'},
        {label: 'Paramètres de projet', to: '/projects/settings/1'},
    ],
    sitemap_admin: [
        {label: 'Liste Utilisateurs', to: '/admin/users'},
        {label: 'Liste Projets', to: '/admin/projects'},
        {label: 'Erreur 404', to: '/erreur/404'},
        {label: 'Erreur 403', to: '/erreur/403'},
        {label: 'Erreur 401', to: '/erreur/401'},
    ],
  }),
  created() {
    this.$store.dispatch("retrieve").then(({ dark }) => {
	  dark = localStorage.getItem('dark');
      this.$dark(dark);
      this.retrieved = true;
    });
    this.verifyToken()
  },
  computed: {
    ...mapGetters('auth', ['isAdmin']),
    logged() {
      return Boolean(this.$store.state.auth.logged);
    },
  },
  methods: {
    ...mapActions({
      verifyToken: "auth/verifyToken",
    }),
    resizeHandler() {
      this.windowSize = window.innerWidth;
    },
    adminMode() {
      // const adminMode = !this.$store.state.adminMode;
      // console.log(adminMode);

      if (this.$store.state.auth.userType === 'Admin') {
        this.$store.state.auth.userType = 'User'
      } else {
        this.$store.state.auth.userType = 'Admin'
      }

      // this.$store.commit('changeState', {
      //   key: 'adminMode',
      //   data: adminMode,
      // });
      // this.$adminMode(adminMode);
    },
  },
  mounted() {
    this.resizeHandler();
    window.addEventListener("resize", this.resizeHandler);
  },
};
</script>
